// extracted by mini-css-extract-plugin
export default {"fill":"skill_rating_icon-module___fill___d172eec0"};